import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faEnvelope, faInfoCircle, faMessage, faPhone, faSquarePhone} from '@fortawesome/free-solid-svg-icons';
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ApiService} from '../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../services/auth.service';
import {validateAllFormFields} from '../../common/utils';
import {LoadingService} from '../services/loading.service';
import {SpinnerComponent} from '../spinner/spinner.component';


@Component({
    selector: 'app-contact-us',
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule, SpinnerComponent],
    templateUrl: './contact-us.component.html',
    styleUrl: './contact-us.component.css'
})
export class ContactUsComponent{
  contactUsForm: FormGroup;
  userName: string = '';
  mobileNumber: string = '';
  userId!: number;

  constructor(private http: HttpClient,
              private library: FaIconLibrary,
              private fb: FormBuilder,
              private apiService: ApiService,
              private toastr: ToastrService,
              private authService: AuthService,
              public loadingService: LoadingService
            ){
          library.addIcons(faPhone,
            faEnvelope,
            faWhatsapp,
            faInfoCircle,
            faMessage,
            faSquarePhone)
          this.getUsername()
          this.contactUsForm = fb.group({
            name: ['', Validators.required],
            mobileNumber: ['', Validators.required],
            comments: ['', Validators.required]
      
          });
         }
  
  getUsername() {
    
    this.userId = this.authService.getCurrentUserInfo()['id']

    if (this.userId){
      this.apiService.getProfiledetail(this.userId).subscribe({
        next: (data: any) => {
          
          this.userName = data['username'];
          this.mobileNumber = data['mobile_number'];
          this.contactUsForm.patchValue({
            name: data['username'],
            mobileNumber: data['mobile_number']
          });
        }, error: (err) => {
          this.toastr.error('Error while getting User Name', 'Error')
        }
      })
    }   
  }
  
  get name(){
    return this.contactUsForm.get('name');
  }
  // get mobileNumber(){
  //   return this.contactUsForm.get('mobileNumber');
  // }
  get comments(){
    return this.contactUsForm.get('comments');
  }

  onSubmit(){

    if (this.contactUsForm.valid) {
      this.loadingService.setLoading('contact-us', true)
      let formData = new FormData();
      formData.append('name', String(this.userId)) 
      formData.append('mobile_number', this.contactUsForm.value.mobileNumber) 
      formData.append('comments', this.contactUsForm.value.comments)
      this.apiService.contactUsPrivate(formData).subscribe({
        next: (response:any) => {
          this.toastr.success('Your query has been submitted successfully. Our support team will contact you soon.', 'Success');
          this.loadingService.setLoading('contact-us', false)

        },error: (err) =>{
          this.loadingService.setLoading('contact-us', false)

          if (err['error']['non_field_errors']) {
            err['error']['non_field_errors'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }
        }
      })

    }else{
      validateAllFormFields(this.contactUsForm)
    }
    
  }

}
